import { StringFormatter } from '@repo/toolkit/string'
import Badge from '@repo/ui/badge'
import { Column, ExpandedColumn } from '@repo/ui/data-table'
import { TableDate } from '@repo/ui/data-table-cells'
import { EuroIcon } from '@repo/ui/icons'

import { API } from '../../api/apis.config'
import DynamicDataTable from '../../components/elements/dynamic-table'
import UserNavBar from '../../components/elements/nav-bar'
import useAuth from '../../lib/hooks/use-auth'
import { priorityEnumMapping } from '../../lib/types/enums/staff-application/priority.enum'
import { staffApplicationStatusEnumMapping } from '../../lib/types/enums/staff-application/staff-application-status.enum'
import {
  StaffApplication,
  StaffApplicationFilters
} from '../../lib/types/models/staff-application/staff-application'

const PcrApplicationsListPage = () => {
  const { user } = useAuth()

  const columns: Column<StaffApplication>[] = [
    {
      accessorKey: 'firstName',
      header: 'NOM du candidat',
      enableSorting: true,
      cell: (data) =>
        `${data.row.original.lastName.toUpperCase()} ${StringFormatter.capitalize(data.row.original.firstName)}`
    },
    {
      accessorKey: 'status',
      header: 'Statut actuel',
      enableSorting: true,
      cell: (data) => (
        <Badge
          text={staffApplicationStatusEnumMapping[data.row.original.status].label}
          variant={staffApplicationStatusEnumMapping[data.row.original.status].variant}
        />
      )
    },
    {
      accessorKey: 'dateAssigned',
      header: "Date d'assignation au PCR",
      enableSorting: true,
      cell: (data) => <TableDate date={data.row.original.dateAssigned} />
    },
    {
      accessorKey: 'priority',
      header: 'Priorité',
      enableSorting: true,
      cell: (data) => (
        <Badge
          text={priorityEnumMapping[data.row.original.priority].label}
          variant={priorityEnumMapping[data.row.original.priority].variant}
        />
      )
    }
  ]

  const similarApplicationColumns: ExpandedColumn<StaffApplication, StaffApplication>[] = [
    {
      accessorKey: 'firstName',
      display: (a) => `${StringFormatter.capitalize(a.firstName)} ${a.lastName.toUpperCase()}`
    },
    {
      accessorKey: 'status',
      display: (a) => (
        <Badge
          text={staffApplicationStatusEnumMapping[a.status].label}
          variant={staffApplicationStatusEnumMapping[a.status].variant}
        />
      )
    },
    {
      accessorKey: 'dateAssigned',
      display: (a) => <TableDate date={a.dateAssigned} />
    },
    {
      accessorKey: 'priority',
      display: (a) => (
        <Badge
          text={priorityEnumMapping[a.priority].label}
          variant={priorityEnumMapping[a.priority].variant}
        />
      )
    }
  ]

  if (!user?.pcr?.id) return null

  return (
    <div>
      <UserNavBar title="Suivi des candidatures" icon={EuroIcon} />
      <div className="h-4" />
      <DynamicDataTable<StaffApplication, StaffApplicationFilters, StaffApplication>
        title="Suivre mes candidatures"
        deleteMessage={{
          name: 'candidature',
          attributeName: 'firstName',
          deleteOne: (staffApplication) =>
            `Êtes-vous sûr de vouloir supprimer la candidature de "${StringFormatter.capitalize(staffApplication.firstName)} ${staffApplication.lastName.toUpperCase()}"?`,
          deleteMany: (staffApplications) =>
            `Êtes-vous sûr de vouloir supprimer ces candidatures "${staffApplications
              .map(
                (staffApplication) =>
                  `${StringFormatter.capitalize(staffApplication.firstName)} ${staffApplication.lastName.toUpperCase()}`
              )
              .join('", "')}"?`,
          deleteAll: 'Êtes-vous sûr de vouloir supprimer toutes les candidatures?'
        }}
        columns={columns}
        allowSearchParam
        version="FULL"
        permissions={{ delete: false }}
        expandedOptions={{ key: 'similarApplications', columns: similarApplicationColumns }}
        endpoint={API.pcr.getStaffApplications.url.replace(':id', user.pcr.id.toString())}
      />
    </div>
  )
}

export default PcrApplicationsListPage
